<ham-modal
    [title]="
        isEditMode
            ? ('aumico_abacus_mapping_edit_title' | i18next)
            : ('aumico_abacus_mapping_add_title' | i18next)
    "
    [size]="'sm'"
    [showCancelButton]="true"
    [cancelText]="'aumico_button_cancel' | i18next"
    [saveText]="'aumico_button_save' | i18next"
    [disabled]="!isFormValid"
    [addHorizontalLineBeforeButtons]="true"
    (cancel)="onCancel()"
    (save)="onSave()"
>
    <div class="abacus-mapping-modal-body">
        <!-- AUMICO COMPANY (locked in edit mode) -->
        <div class="abacus-mapping-modal-body__field">
            <label class="abacus-mapping-modal-body__field-label">
                {{ 'aumico_integration_aumico_company_label' | i18next }}
            </label>
            <!--
                The shared search input owns BOTH the staged-card and the search
                dropdown internally, swapping between them based on `selectedCompany`.
                Two-way bind via `[(selectedCompany)]` so a pick (or "Change" tap)
                updates `selectedAumicoCompany` here, and `[locked]="isEditMode"`
                hides the "Change" button when the company can't be swapped.
            -->
            <aumico-integrations-search-company-input-field
                [options]="aumicoCatalog$ | async"
                [isLoading]="searchIsLoading"
                [hasError]="searchError"
                [placeholder]="'aumico_integration_search_company_placeholder' | i18next"
                [locked]="isEditMode"
                [(selectedCompany)]="selectedAumicoCompany"
            ></aumico-integrations-search-company-input-field>
        </div>

        <!-- Visual divider arrow -->
        <div class="abacus-mapping-modal-body__arrow">↓</div>

        <!-- MANDANTEN ID -->
        <div class="abacus-mapping-modal-body__field">
            <label class="abacus-mapping-modal-body__field-label">
                {{ 'aumico_abacus_mandanten_id_label' | i18next }}
            </label>
            <input
                hamInput
                id="abacusMandantenId"
                type="text"
                inputmode="numeric"
                pattern="[0-9]+"
                [(ngModel)]="mandantenId"
                [placeholder]="'aumico_abacus_mapping_mandanten_id_placeholder' | i18next"
            />
            <small class="abacus-mapping-modal-body__hint">
                {{ 'aumico_abacus_mapping_mandanten_id_help' | i18next }}
            </small>
        </div>
    </div>
</ham-modal>
